import { getEnumValues } from "./helpers";
import { Permission } from "./types";

export const baseApiUrl = "/api";
export const clientVersion = process.env.REACT_APP_VERSION!;
export const urlSafeRegExp = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const permissions = getEnumValues(Permission);
